import { initialState } from './state';

export function set(state, patient) {
  Object.assign(state, patient);
}

export function requireReset(state) {
  Object.assign(state, { isResetRequired: true });
}

export function reset(state) {
  Object.assign(state, initialState());
  Object.assign(state, { isResetRequired: false });
}

export function toggleUnsavedChanges(state, unsavedChanges) {
  Object.assign(state, { unsavedChanges });
}

export function toggleMultipleUnsavedChanges(state, {unsavedChanges, screen, name}) {
  if (!screen) {
    return;
  }
  const _unsaved = [...state.unsavedChangesMultiple];
  const newObject = { name, unsavedChanges, screen }
  const index =_unsaved.findIndex(i => i.name === name);

  // remove item with matching name
  if (unsavedChanges === false && name) {
    const filtered = _unsaved.filter(item => item.name !== name);
    Object.assign(state, { unsavedChangesMultiple: filtered });
    return;
  }

  if (index >= 0) {
    if (_unsaved[index].unsavedChanges === unsavedChanges) {
      return;
    }
    _unsaved.splice(index, 1, newObject)
  } else {
    _unsaved.push(newObject)
  }

  Object.assign(state, { unsavedChangesMultiple: _unsaved });
}

export function removeUnsaved(state) {
  Object.assign(state, {
    unsavedChanges: false,
    unsavedChangesMultiple: []
  });
}

export function updateTargetWeight(state, targetWeight) {
  Object.assign(state.user.patient, {...targetWeight});
}

export function setEventData(state, eventData) {
  state.hadSecondVascularEventOnStatins = eventData
}

export function toggleBlockedAccount(state, blocked) {
  Object.assign(state.user, { blocked });
}